<template>
	<div v-if="bannerPath">
		<a :href="linkURL" target="_blank" rel="noopener">
			<img :src="bannerPath" />
		</a>
	</div>
</template>

<script>
export default {
	props: {
		bannerPath: {
			type: String,
		},
		linkURL: {
			type: String,
		}
	}
}
</script>

<style>

</style>